var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import classNames from 'classnames';
import produce from 'immer';
import { uniq } from 'lodash';
import moment from 'moment';
import React, { useEffect, useReducer, useState } from 'react';
import { Button } from '../Components/Button';
import { ImprovedDataTable } from '../Components/DataTable/ImprovedDataTable';
import { useError } from '../Components/ErrorBoundary';
import { FullScreenModal, FullScreenModalButtonContainer, ModalAnimationStyle } from '../Components/FullScreenModal';
import { ErrorCircleIcon } from '../Components/Icons';
import { LayoutCentral } from '../Components/LayoutCentral';
import { MedicationCard, MedicationCardMode } from '../Components/MedicationCard';
import { NoMedicationsFound } from '../Components/NoMedicationsFound';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { convertTimeOutToMilliSeconds, useMedicationSettings } from '../Config/MedicationConfig';
import { MedicationExpiry, MedicationStatus, MedicationType, OutputType, prettyPrintMedicationCourse, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { ScriptOutputRuleSet } from '../Contracts/MedicationsToFinalise.Request';
import { usePermissions } from '../Hooks/usePermissions';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { buttonVariantColour, calculateCourseInstructions } from '../MedicationSummary/Utilities';
import { removeItemAtIndex } from '../Shared/ArrayUtils';
import { emptyGuid } from '../Shared/Constants';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { isDomainValidationError } from '../Shared/DomainValidationFunctions';
import { expiryStatusFromDate, isInactiveMedicationStatus } from '../Shared/MedicationsHelpers';
import { MedicationExpiryType } from '../Shared/Types';
import { useScriptAcceptedSignalR, useScriptDeclinedSignalR, useScriptExpiredSignalR, useScriptRedeliverSignalR } from '../SignalR/ScriptSignalR';
import { red } from '../Styles/Colours';
import { DecisionSupport } from './DecisionSupport/DecisionSupport';
import { FinalisationPrintSelection } from './FinalisationPrintSelection';
import { FinaliseMedicationErrorTable } from './FinaliseMedicationErrorTable';
import styles from './FinaliseMedicationForm.module.css';
import { FinalisingLoading } from './FinalisingLoading';
import { MedicationActions } from './MedicationActions';
import { NextStepSelector } from './NextStepSelector';
import { ResolutionSelector } from './ResolutionSelector';
import Tooltip from '@material-ui/core/Tooltip';
import { DecisionSupportWarningAlert } from '../DecisionSupportWarningAlert';
import { ColorLinearProgress } from '../Components/ColorLinearProgress';
import CreatingMedicationOrderGraphic from '../Images/creatingMedicationOrder.svg';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
var columnExtensions = [
    {
        columnName: 'product'
    },
    {
        columnName: 'courseInstructions',
        width: 330
    },
    {
        columnName: 'type',
        width: 210
    },
    {
        columnName: 'startedOn',
        align: 'right',
        width: 145
    },
    {
        columnName: 'expiresOn',
        align: 'right',
        width: 145
    },
    {
        columnName: 'status',
        width: 100,
        align: 'right'
    }
];
var RowComponent = function (props) {
    var _a;
    var _b, _c, _d, _e;
    var selectByRowClick = props.selectByRowClick, highlighted = props.highlighted, onToggle = props.onToggle, otherProps = __rest(props, ["selectByRowClick", "highlighted", "onToggle"]);
    var expiryStatus = expiryStatusFromDate(props.tableRow.row.expiresOn);
    var isInactive = isInactiveMedicationStatus(props.tableRow.row.status);
    var rowStyles = classNames(styles.row, (_a = {},
        _a[styles.selectedRow] = highlighted,
        _a[styles.rowExpired] = !isInactive && expiryStatus === MedicationExpiry.Expired,
        _a[styles.rowAboutToExpire] = !isInactive && expiryStatus === MedicationExpiry.AboutToExpire,
        _a));
    var medCode = (_c = (_b = props.tableRow.row) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '';
    var medName = ((_e = (_d = props.tableRow.row) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '').substr(0, 20);
    return (React.createElement(VirtualTable.Row, __assign({}, otherProps, { "data-test-med-code": medCode, "data-test-med-name": medName, row: props.tableRow.row, className: rowStyles })));
};
var CustomCellMemo = function (props) {
    var _a;
    var cellStyles = classNames(styles.cell, (_a = {},
        _a[styles.interactive] = true,
        _a[styles.courseInstructions] = props.column.name === 'courseInstructions',
        _a));
    return React.createElement(VirtualTable.Cell, __assign({}, props, { className: cellStyles, "data-test-id": props.column.name }));
};
var ROW_HEIGHT = 72;
var WizardSteps;
(function (WizardSteps) {
    WizardSteps[WizardSteps["Loading"] = 0] = "Loading";
    WizardSteps[WizardSteps["Selection"] = 1] = "Selection";
    WizardSteps[WizardSteps["DecisionSupport"] = 2] = "DecisionSupport";
    WizardSteps[WizardSteps["Print"] = 3] = "Print";
    WizardSteps[WizardSteps["PharmacyRequest"] = 4] = "PharmacyRequest";
    WizardSteps[WizardSteps["Finalising"] = 5] = "Finalising";
    WizardSteps[WizardSteps["DomainError"] = 6] = "DomainError";
    WizardSteps[WizardSteps["ScriptError"] = 7] = "ScriptError";
    WizardSteps[WizardSteps["ScriptTimeout"] = 8] = "ScriptTimeout";
})(WizardSteps || (WizardSteps = {}));
var SCRIPT_ERROR_CODE = 'Script';
var MIN_FINALISE_DURATION = 1500;
var MAX_FINALISE_DURATION = 15000;
var reducer = produce(function (state, actions) {
    var _a;
    switch (actions.type) {
        case 'StartFinalising':
            state.wizardStep = WizardSteps.Finalising;
            break;
        case 'MedicationsLoaded':
            state.patient = actions.patient;
            state.medications = actions.medications;
            if (actions.medications.length) {
                state.outputSelection = [];
            }
            if (state.selection.length === 0 && actions.autoSelect) {
                state.selection = actions.medications.map(function (it) { return it.id; });
            }
            state.wizardStep = actions.skipToDecisionSupport ? WizardSteps.DecisionSupport : WizardSteps.Selection;
            break;
        case 'ShowDecisionSupportStep':
            state.wizardStep = WizardSteps.DecisionSupport;
            break;
        case 'ShowPharmacyRequestStep':
            state.wizardStep = WizardSteps.PharmacyRequest;
            break;
        case 'RequestErrored':
            state.errors = actions.errors;
            state.wizardStep = WizardSteps.DomainError;
            if (actions.scriptErrors && actions.scriptErrors.length) {
                state.scriptErrors = actions.scriptErrors;
                state.wizardStep = WizardSteps.ScriptError;
            }
            break;
        case 'GotoPrintView':
            state.wizardStep = WizardSteps.Print;
            break;
        case 'FilterSelectionByMedId':
            state.selection = state.selection.filter(function (x) { return x !== actions.medId; });
            break;
        case 'UpdatePatient':
            state.patient = actions.patient;
            if (!((_a = actions.patient) === null || _a === void 0 ? void 0 : _a.mobilePhone)) {
                var itemIndex = state.outputSelection.findIndex(function (it) { return it.medicationType === MedicationType.TakeHomeScript; });
                if (itemIndex >= 0)
                    state.outputSelection = removeItemAtIndex(state.outputSelection, itemIndex);
            }
            break;
        case 'UpdateSelection':
            state.selection = actions.selection;
            break;
        case 'Back':
            if (state.wizardStep === WizardSteps.Print)
                state.wizardStep = WizardSteps.Selection;
            if (state.wizardStep === WizardSteps.DecisionSupport)
                state.wizardStep = WizardSteps.Selection;
            break;
        case 'ToggleOutputSelections': {
            var itemIndex = state.outputSelection.findIndex(function (it) { return it.medicationType === actions.medType; });
            if (itemIndex >= 0)
                state.outputSelection[itemIndex].outputType = actions.outputType;
            else
                state.outputSelection.push({
                    medicationType: actions.medType,
                    outputType: actions.outputType
                });
            break;
        }
        case 'AwaitScriptExchange':
            state.submittedMedications = actions.submittedMedications;
            state.pendingScripts = actions.pendingScripts;
            break;
        case 'ScriptExchangeTimedOut':
            // If the wizard is still in the finalising wait, then it timed out.
            // Otherwise it's moved on, we can ignore the timeout.
            if (state.wizardStep === WizardSteps.Finalising)
                state.wizardStep = WizardSteps.ScriptTimeout;
            break;
        case 'ScriptEventReceived':
            if (actions.eventType === 'Redeliver' ||
                actions.eventType === 'Declined' ||
                actions.eventType === 'Expired')
                state.wizardStep = WizardSteps.ScriptError;
            else {
                state.successfulScripts.push(actions.scriptNumber);
            }
            break;
    }
});
function useModalTitle(state) {
    var _a;
    var medicationSettings = useMedicationSettings();
    var pharmacyRequestTerm = medicationSettings.settings.pharmacyRequestTerm;
    var showPrintStep = state.wizardStep === WizardSteps.Print;
    var loading = state.wizardStep === WizardSteps.Loading;
    var noResults = !loading && state.medications.length === 0;
    var showCreatePharmacyRequest = state.wizardStep === WizardSteps.PharmacyRequest;
    if (showPrintStep)
        return "Here's your medication that will be finalised as part of this service";
    if (showCreatePharmacyRequest)
        return "Do you need to create a new " + ((_a = pharmacyRequestTerm === null || pharmacyRequestTerm === void 0 ? void 0 : pharmacyRequestTerm.singularTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase()) + "?";
    if (state.wizardStep === WizardSteps.DecisionSupport)
        return '';
    if (state.wizardStep === WizardSteps.DomainError || state.errors.length > 0)
        return 'Uh oh! We’ve found some errors';
    if (state.wizardStep === WizardSteps.ScriptError || state.wizardStep === WizardSteps.ScriptTimeout)
        return 'Uh oh! The script exchange has errors';
    if (noResults)
        return '';
    return 'Finalise your patient’s medication';
}
function useModalInfoLine(state) {
    var showPrintStep = state.wizardStep === WizardSteps.Print;
    var loading = state.wizardStep === WizardSteps.Loading;
    var noResults = !loading && state.medications.length === 0;
    var showCreatePharmacyRequest = state.wizardStep === WizardSteps.PharmacyRequest;
    if (showPrintStep)
        return '';
    if (showCreatePharmacyRequest)
        return "";
    if (state.wizardStep === WizardSteps.DecisionSupport)
        return '';
    if (state.wizardStep === WizardSteps.DomainError || state.errors.length > 0)
        return 'Please resolve the following errors highlighted below.';
    if (state.wizardStep === WizardSteps.ScriptError || state.wizardStep === WizardSteps.ScriptTimeout)
        return 'Select an option to resolve the issue.';
    if (noResults)
        return '';
    return 'Select what medication you’d like to finalise as part of your service. Finalising medication will group it into batches and generate a script number.';
}
function calculateProgress(state) {
    var wizardStep = state.wizardStep;
    if (wizardStep === WizardSteps.Loading)
        return 0;
    if (wizardStep === WizardSteps.Selection)
        return 25;
    if (wizardStep === WizardSteps.DecisionSupport)
        return 50;
    if (wizardStep === WizardSteps.Print)
        return 100;
    return;
}
function shouldSkipPrintStepDialog(state, selectedMeds) {
    var skipPrint = false;
    var totalEnrmcScripts = selectedMeds.filter(function (it) { return it.type === MedicationType.EnrmcScript; }).length;
    var totalComplementaryTherapyOrders = selectedMeds.filter(function (it) { return it.type === MedicationType.ComplementaryTherapyOrder; }).length;
    if (selectedMeds.length > 1 && totalEnrmcScripts + totalComplementaryTherapyOrders === selectedMeds.length)
        skipPrint = true;
    else if (selectedMeds.length > 0 && totalEnrmcScripts === selectedMeds.length)
        skipPrint = true;
    else
        skipPrint = false;
    return skipPrint;
}
export var FinaliseMedicationForm = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(useReducer(reducer, {
        wizardStep: WizardSteps.Loading,
        medications: [],
        outputSelection: [],
        selection: [],
        errors: [],
        scriptErrors: [],
        submittedMedications: null,
        pendingScripts: [],
        successfulScripts: [],
        patient: null
    }), 2), state = _e[0], dispatch = _e[1];
    var throwError = useError();
    var medicationSettings = useMedicationSettings();
    var skipToDecisionSupport = (_b = (_a = medicationSettings === null || medicationSettings === void 0 ? void 0 : medicationSettings.settings) === null || _a === void 0 ? void 0 : _a.alwaysCreatePharmacyRequest) !== null && _b !== void 0 ? _b : false;
    var _f = __read(useState((_d = (_c = medicationSettings === null || medicationSettings === void 0 ? void 0 : medicationSettings.settings) === null || _c === void 0 ? void 0 : _c.alwaysCreatePharmacyRequest) !== null && _d !== void 0 ? _d : false), 2), headless = _f[0], setHeadless = _f[1];
    var _g = __read(useState(false), 2), startedFinalizing = _g[0], setStartedFinalizing = _g[1];
    var loadData = function (autoSelect) {
        if (autoSelect === void 0) { autoSelect = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, props.getMedicationsToFinalise()];
                    case 1:
                        data = _a.sent();
                        dispatch({
                            type: 'MedicationsLoaded',
                            medications: data.medications,
                            skipToDecisionSupport: skipToDecisionSupport,
                            autoSelect: autoSelect,
                            patient: data.patient
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        throwError(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var medicationsFinalised = function (meds) {
        var _a;
        if (permissions.writePharmacyRequest) {
            if ((_a = medicationSettings === null || medicationSettings === void 0 ? void 0 : medicationSettings.settings) === null || _a === void 0 ? void 0 : _a.alwaysCreatePharmacyRequest)
                props.onGotoCreatePharmacyRequest();
            else {
                displayMessage(meds.medications.length > 1 ? 'Medications finalised' : 'Medication finalised');
                dispatch({ type: 'ShowPharmacyRequestStep' });
            }
        }
        else {
            displayMessage(meds.medications.length > 1 ? 'Medications finalised' : 'Medication finalised');
            props.onSuccess();
        }
    };
    useScriptAcceptedSignalR({
        encounter: props.encounter,
        onSignalResponse: function (event) {
            console.log('FinaliseMedicationForm - ScriptEventReceived - Accepted: ', event);
            dispatch({
                type: 'ScriptEventReceived',
                eventType: 'Accepted',
                scriptNumber: event.authoringSystemForeignKey
            });
        }
    });
    useScriptDeclinedSignalR({
        encounter: props.encounter,
        onSignalResponse: function (event) {
            console.error('FinaliseMedicationForm - ScriptEventReceived - Declined: ', event);
            dispatch({
                type: 'ScriptEventReceived',
                eventType: 'Declined',
                scriptNumber: event.authoringSystemForeignKey
            });
        }
    });
    useScriptRedeliverSignalR({
        encounter: props.encounter,
        onSignalResponse: function (event) {
            console.error('FinaliseMedicationForm - ScriptEventReceived - Redeliver: ', event);
            dispatch({
                type: 'ScriptEventReceived',
                eventType: 'Redeliver',
                scriptNumber: event.authoringSystemForeignKey
            });
        }
    });
    useScriptExpiredSignalR({
        encounter: props.encounter,
        onSignalResponse: function (event) {
            console.error('Script expired - event: ', event);
            dispatch({
                type: 'ScriptEventReceived',
                eventType: 'Expired',
                scriptNumber: event.authoringSystemForeignKey
            });
        }
    });
    useEffect(function () {
        var pendingScriptIds = state.pendingScripts.map(function (it) { return it.scriptNumber; });
        var successfulScriptIdsForPendingScripts = state.successfulScripts.filter(function (it) {
            return pendingScriptIds.includes(it);
        });
        if (state.wizardStep === WizardSteps.Finalising &&
            pendingScriptIds.length > 0 &&
            successfulScriptIdsForPendingScripts.length > 0 &&
            pendingScriptIds.length === successfulScriptIdsForPendingScripts.length &&
            state.submittedMedications) {
            medicationsFinalised(state.submittedMedications);
        }
    }, [state.wizardStep, state.pendingScripts.length, state.successfulScripts.length]);
    useEffect(function () {
        if (!loading && headless && !startedFinalizing) {
            setStartedFinalizing(true);
            submitMedsForFinalisation();
        }
    }, [state.wizardStep]);
    var hasErrors = state.errors.length > 0;
    var _h = __read(useState(false), 2), shouldCreatePharmacyRequest = _h[0], setShouldCreatePharmacyRequest = _h[1];
    var permissions = usePermissions({
        writePharmacyRequest: MedicationsPermissions.WritePharmacyRequest
    });
    var submitMedsForFinalisation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var timeout, selectedMeds, selectedTypes, outputSelections, meds, _a, results, pendingScripts, maxFinaliseDuration, err_1, errorMessage, errors, apiScriptErrors, nonScriptErrors;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    timeout = new Promise(function (resolve) { return setTimeout(resolve, MIN_FINALISE_DURATION); });
                    dispatch({ type: 'StartFinalising' });
                    selectedMeds = state.medications.filter(function (it) { return state.selection.includes(it.id); });
                    selectedTypes = uniq(selectedMeds.map(function (it) { return it.type; }));
                    outputSelections = state.outputSelection.filter(function (it) { return selectedTypes.includes(it.medicationType); });
                    meds = {
                        outputSelections: outputSelections,
                        generatedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                        service: {
                            id: emptyGuid,
                            authoringSystem: props.serviceAuthoringSystem,
                            authoringSystemForeignKey: props.serviceAuthoringSystemForeignKey
                        },
                        medications: selectedMeds.map(function (it) { return ({
                            id: it.id,
                            authoringSystem: it.authoringSystem,
                            authoringSystemForeignKey: it.authoringSystemForeignKey
                        }); }),
                        scriptOutputRuleSet: ScriptOutputRuleSet.EPrescription
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, Promise.all([props.onFinaliseMedications(meds), timeout])];
                case 2:
                    _a = __read.apply(void 0, [_c.sent(), 1]), results = _a[0];
                    pendingScripts = results.filter(function (it) { return it.outputType === OutputType.SendScript; });
                    // If there are pending scripts, then we start the clock.
                    if (pendingScripts.length) {
                        dispatch({ type: 'AwaitScriptExchange', pendingScripts: pendingScripts, submittedMedications: meds });
                        maxFinaliseDuration = medicationSettings.settings.scriptExchangeTimeout != null &&
                            medicationSettings.settings.scriptExchangeTimeout.number > 0
                            ? convertTimeOutToMilliSeconds(medicationSettings.settings.scriptExchangeTimeout.number, medicationSettings.settings.scriptExchangeTimeout.timeUnits)
                            : MAX_FINALISE_DURATION;
                        // Start the ERX timeout
                        setTimeout(function () {
                            dispatch({ type: 'ScriptExchangeTimedOut' });
                            setHeadless(false);
                        }, maxFinaliseDuration);
                    }
                    else {
                        // If there are no pending scripts, just finalise it.
                        medicationsFinalised(meds);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    return [4 /*yield*/, timeout];
                case 4:
                    _c.sent();
                    errorMessage = meds.medications.length > 1 ? 'Unable to finalise medications' : 'Unable to finalise medication';
                    displayError(errorMessage);
                    setHeadless(false);
                    if (isDomainValidationError(err_1)) {
                        errors = (_b = err_1.content) !== null && _b !== void 0 ? _b : [];
                        apiScriptErrors = errors.filter(function (it) { return it.propertyName === SCRIPT_ERROR_CODE; });
                        nonScriptErrors = errors.filter(function (it) { return it.propertyName !== SCRIPT_ERROR_CODE; });
                        dispatch({
                            type: 'RequestErrored',
                            errors: nonScriptErrors,
                            scriptErrors: apiScriptErrors
                        });
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadData();
    }, []);
    var loading = state.wizardStep === WizardSteps.Loading;
    var noResults = !loading && state.medications.length === 0;
    var showCreatePharmacyRequest = state.wizardStep === WizardSteps.PharmacyRequest;
    var showDecisionSupportStep = state.wizardStep === WizardSteps.DecisionSupport;
    var hasScriptError = state.wizardStep === WizardSteps.ScriptTimeout || state.wizardStep === WizardSteps.ScriptError;
    var showPrintStep = state.wizardStep === WizardSteps.Print;
    var finalising = state.wizardStep === WizardSteps.Finalising;
    var selectedMeds = state.medications.filter(function (it) { return state.selection.includes(it.id); });
    var takeHomeScriptsSelected = selectedMeds.findIndex(function (it) { return it.type === MedicationType.TakeHomeScript; }) >= 0;
    var noOutputOptionForTakeHomeScript = state.outputSelection.filter(function (it) { return it.medicationType === MedicationType.TakeHomeScript; }).length === 0;
    var disableContinueButton = loading ||
        state.selection.length === 0 ||
        (state.wizardStep === WizardSteps.Print && takeHomeScriptsSelected && noOutputOptionForTakeHomeScript);
    var skipPrintStep = shouldSkipPrintStepDialog(state, selectedMeds);
    var handleClose = function () {
        props.onClose(hasScriptError);
    };
    var decisionSupportSettings = medicationSettings.settings.decisionSupportSettings;
    var enableDecisionSupport = decisionSupportSettings.prescriptionMonitoringEnabled ||
        decisionSupportSettings.medicationToConditionEnabled ||
        decisionSupportSettings.medicationToAllergiesEnabled ||
        decisionSupportSettings.medicationToMedicationEnabled ||
        decisionSupportSettings.medicationToPregnancyEnabled;
    var handleDecisionSupportContinue = function () {
        if (hasScriptError)
            return;
        else if ((state.wizardStep === WizardSteps.Selection || state.wizardStep === WizardSteps.DecisionSupport) &&
            !skipPrintStep)
            dispatch({ type: 'GotoPrintView' });
        else
            submitMedsForFinalisation();
    };
    var buttons = showCreatePharmacyRequest ? (React.createElement(Button, { key: 'continue', width: 168, type: 'button', disabled: loading, testId: 'navigation-control-Continue', onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (shouldCreatePharmacyRequest)
                props.onGotoCreatePharmacyRequest();
            else
                props.onSuccess();
        } }, "Continue")) : hasErrors ? ([
        React.createElement(Button, { key: 'cancel', width: 168, type: 'button', disabled: loading || state.selection.length === 0, testId: 'navigation-control-close', onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
            } }, "Cancel")
    ]) : noResults ? ([]) : showDecisionSupportStep ? ([]) : ([
        React.createElement(Button, { key: 'continue', width: 168, type: 'button', disabled: disableContinueButton, testId: 'navigation-control-Continue', onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (hasScriptError)
                    return;
                else if (state.wizardStep === WizardSteps.Print)
                    submitMedsForFinalisation();
                else if (enableDecisionSupport) {
                    dispatch({ type: 'ShowDecisionSupportStep' });
                }
                else {
                    handleDecisionSupportContinue();
                }
            } }, "Continue")
    ]);
    var modalTitle = useModalTitle(state);
    var modalInfo = useModalInfoLine(state);
    var progress = calculateProgress(state);
    if (!headless) {
        return (React.createElement(FullScreenModal, { header: hasScriptError && React.createElement(ErrorCircleIcon, { noPadding: true, noCircularContainer: true, size: '64', color: red }), title: modalTitle, hideBackButton: skipToDecisionSupport ||
                (!showDecisionSupportStep && (hasErrors || !showPrintStep || showCreatePharmacyRequest)), progressPercent: progress, onBack: function () {
                dispatch({ type: 'Back' });
            }, modalAnimationStyle: permissions.writePharmacyRequest && shouldCreatePharmacyRequest
                ? ModalAnimationStyle.OpenOnly
                : ModalAnimationStyle.OpenAndClose, info: modalInfo, onClose: showCreatePharmacyRequest ? props.onSuccess : handleClose, nonInteractivePlaceholder: finalising ? React.createElement(FinalisingLoading, null) : null },
            React.createElement(FinaliseMedicationFormBody, { state: state, patient: props.patient, shouldCreatePharmacyRequest: shouldCreatePharmacyRequest, encounter: props.encounter, onView: props.onView, onClose: handleClose, showPharmacyStep: function () { return dispatch({ type: 'ShowPharmacyRequestStep' }); }, onGotoCreatePharmacyRequest: props.onGotoCreatePharmacyRequest, toggleShouldCreatePharmacyRequest: setShouldCreatePharmacyRequest, onPatientUpdated: function (patient) {
                    dispatch({
                        type: 'UpdatePatient',
                        patient: patient
                    });
                }, onMedicationDeleted: function (medId) {
                    loadData(false);
                    dispatch({
                        type: 'FilterSelectionByMedId',
                        medId: medId
                    });
                    props.onMedicationDeleted(medId);
                }, onDecisionSupportContinue: handleDecisionSupportContinue, deleteMedication: props.deleteMedication, onSelectionChange: function (newSelection) {
                    dispatch({ type: 'UpdateSelection', selection: newSelection });
                }, toggleOutputSelections: function (medType, outputType) {
                    dispatch({ type: 'ToggleOutputSelections', medType: medType, outputType: outputType });
                }, showPatientDialog: props.showPatientDialog }),
            React.createElement(FullScreenModalButtonContainer, null, buttons)));
    }
    else {
        return (React.createElement(StyledDialog, { open: true, size: 'sm', modal: true, testId: 'finalise-medication-loading-dialog', contentComponent: React.createElement(LayoutCentral, null,
                React.createElement("div", { className: styles.body },
                    React.createElement("img", { src: CreatingMedicationOrderGraphic, alt: '' }),
                    React.createElement("div", { className: styles.modalHeader },
                        "Finalising your ",
                        React.createElement("span", { className: styles.modalHeaderEmphasis }, "medication")),
                    React.createElement("div", { className: styles.info }, "We're preparing your medication..."),
                    React.createElement(ColorLinearProgress, { className: styles.progress }))) }));
    }
};
var MedicationTypeAndCourse = function (props) {
    return (React.createElement("div", null,
        React.createElement("div", null, prettyPrintMedicationType(props.type)),
        React.createElement("div", { className: styles.course }, prettyPrintMedicationCourse(props.course))));
};
function FinaliseMedicationFormBody(props) {
    var _a;
    var medicationSettings = useMedicationSettings();
    var pharmacyRequestTerm = medicationSettings.settings.pharmacyRequestTerm;
    var state = props.state;
    var showPrintStep = state.wizardStep === WizardSteps.Print;
    var showDecisionSupportStep = state.wizardStep === WizardSteps.DecisionSupport;
    var loading = state.wizardStep === WizardSteps.Loading;
    var noResults = !loading && state.medications.length === 0;
    var showCreatePharmacyRequest = state.wizardStep === WizardSteps.PharmacyRequest;
    var hasErrors = state.errors.length > 0;
    var getColumns = function () {
        return [
            {
                name: 'product',
                title: 'Product',
                getCellValue: function (row) {
                    var isSelected = state.selection.includes(row.id);
                    var strength = Number(row.strength);
                    return (React.createElement(MedicationCard, { name: row.name, strength: isNaN(strength) ? 0 : strength, strengthUnit: row.strengthUnits, type: row.type, selected: isSelected, size: row.packAmount, productPackAmount: row.productPackAmount, repeatsAmount: row.repeatsAmount, mode: MedicationCardMode.Long, isNonStandardPackSize: row.isNonStandardPackSize, nonStandardPackSize: row.nonStandardPackSize }));
                }
            },
            {
                name: 'courseInstructions',
                title: 'Order instructions',
                getCellValue: function (row) {
                    var instructions = calculateCourseInstructions({
                        orderInstructions: row.orderInstruction,
                        dosageInstructions: row.dosageInstruction,
                        type: row.type
                    });
                    return (React.createElement(Tooltip, { title: instructions, placement: 'bottom-start' },
                        React.createElement("div", { className: classNames(styles.rowMainText, styles.wrappingCell) }, instructions)));
                }
            },
            {
                name: 'type',
                title: 'Type',
                getCellValue: function (row) {
                    return React.createElement(MedicationTypeAndCourse, { course: row.course, type: row.type });
                }
            },
            {
                name: 'startedOn',
                title: 'Start date',
                getCellValue: function (row) {
                    return moment(row.performedOn).format(ValidDateFormats.Edit);
                }
            },
            {
                name: 'expiresOn',
                title: 'End date',
                getCellValue: function (row) {
                    if (row.medicationExpiry === MedicationExpiryType.Chart) {
                        return React.createElement("span", { className: styles.chartDuration }, "(Chart duration)");
                    }
                    else {
                        var expiresOn = moment(row.expiresOn);
                        return expiresOn.isValid() ? expiresOn.format(ValidDateFormats.Edit) : '';
                    }
                }
            },
            {
                name: 'status',
                title: ' ',
                getCellValue: function (row) {
                    var selected = state.selection.includes(row.id);
                    var expiryStatus = expiryStatusFromDate(row.expiresOn);
                    var stopped = row.status === MedicationStatus.Stopped;
                    var expired = !stopped && expiryStatus === MedicationExpiry.Expired;
                    var aboutToExpire = !stopped && expiryStatus === MedicationExpiry.AboutToExpire;
                    return (React.createElement(MedicationActions, { row: row, buttonVariantColour: buttonVariantColour(selected, expired, aboutToExpire), onView: props.onView, onDelete: props.onMedicationDeleted, deleteMedication: props.deleteMedication }));
                }
            }
        ];
    };
    if (noResults)
        return (React.createElement(LayoutCentral, null,
            React.createElement(NoMedicationsFound, { largeMode: true, title: 'No medication to finalise', info: "No medication available to finalise. Please add a new medication to your patient\u2019s record or click continue to create your " + ((_a = pharmacyRequestTerm === null || pharmacyRequestTerm === void 0 ? void 0 : pharmacyRequestTerm.singularTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase()), useAlt: true, backLinkText: 'Back to medication summary', onClickBack: props.onClose, showForwardButton: true, forwardLinkText: 'Continue', onClickForward: function () {
                    var _a;
                    if ((_a = medicationSettings === null || medicationSettings === void 0 ? void 0 : medicationSettings.settings) === null || _a === void 0 ? void 0 : _a.alwaysCreatePharmacyRequest)
                        props.onGotoCreatePharmacyRequest();
                    else
                        props.showPharmacyStep();
                } })));
    if (showDecisionSupportStep) {
        return (React.createElement(DecisionSupport, { patient: props.patient, excludeNotedDecisionSupport: true, onContinue: props.onDecisionSupportContinue, onNavigateToMedication: props.onView }));
    }
    if (showCreatePharmacyRequest)
        return (React.createElement(NextStepSelector, { shouldCreatePharmacyRequest: props.shouldCreatePharmacyRequest, pharmacyRequestTerm: pharmacyRequestTerm, onYes: function () {
                props.toggleShouldCreatePharmacyRequest(true);
            }, onNo: function () {
                props.toggleShouldCreatePharmacyRequest(false);
            } }));
    if (loading)
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    if (hasErrors)
        return (React.createElement("div", { className: styles.tableContainer },
            React.createElement(FinaliseMedicationErrorTable, { medications: state.medications, errors: state.errors, onView: props.onView })));
    if (state.wizardStep === WizardSteps.ScriptError || state.wizardStep === WizardSteps.ScriptTimeout)
        return (React.createElement("div", { className: styles.resolutionContainer },
            React.createElement(ResolutionSelector, null)));
    // Currently no special handling for timeouts.
    // if (state.wizardStep === WizardSteps.ScriptTimeout)
    //     return (
    //         <div>
    //             Uh oh! The script exchange has timed out Select an option to resolve the issue. Re-submit Medications
    //             Send the patient’s medications to the exchange again Print Scripts Provide patient with hard copy of the
    //             script.
    //         </div>
    //     );
    // Should never be in the state of patient == null
    if (showPrintStep && state.patient)
        return (React.createElement(FinalisationPrintSelection, { medications: state.medications.filter(function (it) { return state.selection.includes(it.id); }), encounter: props.encounter, outputSelections: state.outputSelection, toggleOutputSelection: props.toggleOutputSelections, patient: state.patient, showPatientDialog: props.showPatientDialog, onPatientUpdated: props.onPatientUpdated }));
    return (React.createElement("div", { className: styles.tableContainer },
        React.createElement("div", { className: styles.decisionSupportWarningAlertContainer },
            React.createElement(DecisionSupportWarningAlert, null)),
        React.createElement(ImprovedDataTable, { columns: getColumns(), rowHeight: ROW_HEIGHT, data: state.medications, cellComponent: CustomCellMemo, getRowId: function (item) { return item.id; }, rowChecking: {
                selectedIds: state.selection,
                showSelectAll: true,
                showSelectionColumn: true,
                onSelectedChanged: props.onSelectionChange,
                rowComponent: RowComponent
            }, columnExtensions: columnExtensions })));
}
